import { Fragment, MouseEvent, ReactNode } from 'react';
import { FilterPreferenceRecognizedLists } from '../../../services/modules/userContextPreferences/userContextPreferences.types';
import { FilterOptionV3, FilterProps } from '../../Crud/filters/sharedBetweenFilters/types';
import FilterBar from '../../v2/ui/FilterBar/FilterBar';
import SelectedFilterList from './Filter/SelectedFilter/SelectedFilterList';

interface UnifiedFilterBarProps {
  searchField?: ReactNode;
  fixedFilters?: ReactNode[];
  list: FilterPreferenceRecognizedLists;
  formattedFilters: (FilterOptionV3 & { hasValue: boolean })[];
  hasSelectedFilter: boolean;
  hasFixedFilter: boolean;
  hasActiveFixedFilter: boolean;
  isSearchActive?: boolean;
  onClickSelectedFilter: (event: MouseEvent<HTMLElement>, filter: FilterProps) => void;
  onClearAll: () => void;
}

function UnifiedFilterBar({
  searchField,
  fixedFilters,
  list,
  formattedFilters,
  hasSelectedFilter,
  hasFixedFilter,
  hasActiveFixedFilter,
  isSearchActive,
  onClickSelectedFilter,
  onClearAll,
}: UnifiedFilterBarProps) {
  return (
    <FilterBar
      searchField={searchField}
      hasActiveSearch={isSearchActive || hasFixedFilter}
      fixedFilters={
        fixedFilters?.length
          ? fixedFilters.map((fixedFilter, index) => (
              <Fragment key={`fixed-filter-${index}`}>{fixedFilter}</Fragment>
            ))
          : undefined
      }
      chips={
        hasSelectedFilter ? (
          <SelectedFilterList
            list={list}
            filters={formattedFilters}
            onClick={onClickSelectedFilter}
          />
        ) : null
      }
      onClearAll={
        hasSelectedFilter || isSearchActive || hasActiveFixedFilter ? onClearAll : undefined
      }
    />
  );
}

export default UnifiedFilterBar;
